export const ToResidentSmsTypes = {
  SHOW_SMS_RESIDENT: "SHOW_SMS_RESIDENT",
  SEND_SMS_RESIDENT_PREVIEW: "SEND_SMS_RESIDENT_PREVIEW",
  SEND_SMS_RESIDENT: "SEND_SMS_RESIDENT",
}